"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultObfuscationKeys = exports.DataAccessGroups = void 0;
exports.DataAccessGroups = {
    ENV_CLIENT: 'env:client',
};
exports.defaultObfuscationKeys = ['password', 'apiKey', 'api_key', 'secret'];
//# sourceMappingURL=security.js.map